import DeleteIcon from 'assets/settings/components/DeleteIcon';
import EditIcon from 'assets/settings/components/EditIcon';
import Switch from 'common-ui/switch';

import {
  ActionButton,
  ActionsRow,
  Card,
  CardHeader,
  ClockIcon,
  DisabledBadge,
  EnabledBadge,
  HeaderLeft,
  HeaderText,
  SwitchLabel,
  SwitchRow,
  ValueText,
} from './NotificationCard.styles';

const NotificationCard = ({ notification, onToggle, onEdit, onDelete }) => {
  return (
    <Card>
      <CardHeader>
        <HeaderLeft>
          <ClockIcon />
          <HeaderText title={notification.name}>{notification.name}</HeaderText>
        </HeaderLeft>
        {notification.enabled ? (
          <EnabledBadge>Enabled</EnabledBadge>
        ) : (
          <DisabledBadge>Disabled</DisabledBadge>
        )}
      </CardHeader>

      <ValueText>
        {notification.offsetValue} <span>{notification.offsetType} </span>
      </ValueText>

      <SwitchRow>
        <Switch
          isOn={notification.enabled}
          onToggle={() => onToggle(notification.id)}
          disabled={false}
        />
        <SwitchLabel>{notification.enabled ? 'Active' : 'Inactive'}</SwitchLabel>
        <ActionsRow>
          <ActionButton onClick={() => onEdit(notification.id)}>
            <EditIcon size={16} color="#2D6CDF" />
          </ActionButton>
          <ActionButton onClick={() => onDelete(notification.id)} $delete>
            <DeleteIcon size={16} color="#FB2C36" />
          </ActionButton>
        </ActionsRow>
      </SwitchRow>
    </Card>
  );
};

export default NotificationCard;
